import React from 'react'
import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'
import { useTranslation } from 'react-i18next'
import PageHeroTitle from '../components/PageHeroTitle'
import BottomImage from '../components/BottomImage'

const CGU = () => {
  const { t } = useTranslation()
  const pageName = 'TERMS_OF_USE'

  return (
    <div>
      <NavigationBar />

      <PageHeroTitle title={t(pageName)} description="" />
      <div className="p-3">
        <h2>Article 1 - Objet</h2>
        <p>
          Les présentes conditions générales d'utilisation (ci-après les "CGU")
          ont pour objet de définir les règles et conditions applicables à
          l'utilisation du site web www.revesdebarousse.fr (ci-après le "Site").
        </p>

        <hr />

        <h2>Article 2 - Définitions</h2>
        <ul>
          <li>
            <strong>Utilisateur</strong> : Toute personne physique ou morale qui
            accède et utilise le Site.
          </li>
          <li>
            <strong>Contenu</strong> : Ensemble des éléments constituant le
            Site, notamment les textes, images, vidéos, sons, et bases de
            données.
          </li>
          <li>
            <strong>Propriétaire</strong> : La personne physique ou morale
            titulaire des droits de propriété intellectuelle sur le Contenu du
            Site.
          </li>
        </ul>

        <hr />
        <h2>Article 3 - Accès et utilisation du Site</h2>
        <p>
          L'accès au Site est libre et gratuit. L'Utilisateur s'engage à
          utiliser le Site de manière conforme aux présentes CGU et aux lois et
          règlements en vigueur.
        </p>

        <hr />
        <h2>Article 4 - Propriété intellectuelle</h2>
        <p>
          Le Contenu du Site est protégé par les droits de propriété
          intellectuelle du Propriétaire. L'Utilisateur s'engage à ne pas
          reproduire, copier, modifier, diffuser, ou exploiter de quelque
          manière que ce soit le Contenu du Site sans l'autorisation expresse et
          écrite du Propriétaire.
        </p>

        <hr />
        <h2>Article 5 - Responsabilité</h2>
        <p>
          Le Propriétaire ne peut être tenu responsable des dommages directs ou
          indirects, matériels ou immatériels, causés par l'utilisation du Site
          ou de son Contenu.
        </p>

        <hr />
        <h2>Article 6 - Liens hypertextes</h2>
        <p>
          Le Site peut contenir des liens hypertextes vers d'autres sites web.
          Le Propriétaire ne peut être tenu responsable du contenu de ces sites
          web.
        </p>

        <hr />
        <h2>Article 7 - Modification des CGU</h2>
        <p>
          Le Propriétaire se réserve le droit de modifier les présentes CGU à
          tout moment. Les modifications entreront en vigueur dès leur
          publication sur le Site.
        </p>

        <hr />
        <h2>Article 8 - Loi applicable et juridiction compétente</h2>
        <p>
          Les présentes CGU sont soumises au droit français. En cas de litige,
          les tribunaux français seront seuls compétents.
        </p>

        <hr />
        <h2>Article 9 - Contact</h2>
        <p>
          Pour toute question ou réclamation, l'Utilisateur est invité à
          utiliser le formulaire de contact disponible sur le Site.
        </p>

        <hr />
        <h2>Article 10 - Inscription et création d'un compte</h2>
        <p>
          L'Utilisateur peut créer un compte sur le Site en remplissant un
          formulaire d'inscription et en choisissant un mot de passe.
        </p>
        <p>
          L'Utilisateur est responsable de la sécurité de son compte et de son
          mot de passe.
        </p>

        <hr />
        <h2>Article 11 - Politique de confidentialité</h2>
        <p>
          Le Propriétaire collecte des données personnelles lors de
          l'inscription de l'Utilisateur, de la passation d'une commande et de
          la navigation sur le Site.
        </p>
        <p>
          Les données collectées sont les suivantes : nom, prénom, adresse
          email, adresse postale, numéro de téléphone, données de connexion et
          de navigation.
        </p>
        <p>
          Le Propriétaire s'engage à ne pas transmettre les données collectées à
          des tiers sans le consentement de l'Utilisateur.
        </p>
        <p>
          L'Utilisateur dispose d'un droit d'accès, de rectification, de
          suppression et d'opposition aux données le concernant.
        </p>

        <hr />
        <h2>Article 12 - Cookies</h2>
        <p>
          Le Site utilise des cookies pour améliorer l'expérience utilisateur et
          à des fins de statistiques.
        </p>
        <p>L'Utilisateur peut accepter ou refuser l'utilisation des cookies.</p>
        <p>
          L'Utilisateur peut paramétrer son navigateur pour refuser
          l'installation de cookies.
        </p>

        <hr />
        <h2>Article 13 - Conditions de vente</h2>
        <p>
          <strong>1. Produits et services</strong>
        </p>
        <p>Le Site propose à la vente des produits et services.</p>
        <p>
          Les produits et services sont vendus aux prix indiqués sur le Site.
        </p>
        <p>Les prix sont TTC et incluent les frais de livraison.</p>

        <p>
          <strong>2. Commande</strong>
        </p>
        <p>
          L'Utilisateur passe commande en sélectionnant les produits et services
          souhaités et en validant son panier.
        </p>
        <p>
          L'Utilisateur doit fournir ses informations de facturation et de
          livraison
        </p>

        <BottomImage name={pageName} />
      </div>

      <Footer />
    </div>
  )
}

export default CGU
